import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrEmpty } from '../../core/utils/common-functions';

/**
 * 轉換選項對應的文字顯示
 *
 * @export
 * @param {*} value
 * @param {{ label?: string, value: any }[]} options
 * @param {boolean} [showValue=false]
 * @return {*}  {*}
 */
export function formatOptions(
  value: any,
  options: { label?: string; value: any }[],
  showValue: boolean = false
): any {
  const option = options?.find((x) => x.value === value);
  if (showValue) {
    if (isNullOrEmpty(option)) {
      return value;
    } else {
      if (isNullOrEmpty(option!.label)) {
        return value;
      } else {
        return isNullOrEmpty(value)
          ? option!.label
          : `${option!.value} ${option!.label}`;
      }
    }
  }
  return option?.label ?? value;
}
export function formatOptionsForLocale(
  value: any,
  options: any,
  showValue: boolean = false,
  localeLang?: string
): any {
  const option = options?.find((x: { value: any }) => x.value === value);
  if (showValue) {
    if (isNullOrEmpty(option)) {
      return value;
    } else {
      if (isNullOrEmpty(option!.label)) {
        return value;
      } else {
        return isNullOrEmpty(value)
          ? option!.label
          : `${option!.value} ${option!.label}`;
      }
    }
  }
  if (!isNullOrEmpty(localeLang)) {
    let i18nCode = option?.dropdown.languageOther.find(
      (x: { i18nCode: string | undefined }) => x.i18nCode === localeLang
    );
    return i18nCode ? i18nCode.i18nValue : value;
  }
  return option?.label ?? value;
}
@Pipe({
  name: 'optionsMapping',
  pure: false,
})
export class OptionsMappingPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const options: { label: string; value: any }[] = args[0];
    const option = options.find((x) => x.value === value);
    return option?.label ?? value;
  }
}
